
export const ThePics = [
  {
    title: "Verilog仿真",
    desc: "精确的验证从每一行代码开始！Verilog仿真，让你轻松驾驭复杂的硬件设计。高效、精准、全面无死角地捕捉每一个信号，让调试过程变得轻松愉快。无论是模拟测试还是性能验证，我们的工具都将帮助你在设计中高效解决每一个难题，打造无可挑剔的芯片设计。",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/sim.png'
  },
  {
    title: "RTL2GDS",
    desc: "从设计蓝图到实际布局，只需一步！RTL2GDS打破设计流程中的壁垒，一键完成从RTL代码到GDS文件的完美转换，让每一块设计都精准无误。流畅的输出流程和可靠的结果，保证设计的效率与质量，带领你的芯片从构思到实现，完美呈现。",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/rtl2gds.png',
  },
  {
    title: "Agents",
    desc: "将测试推向智能化的未来！Agent系统不仅模拟真实环境中的每个行为，更能深度挖掘潜藏的每个问题。凭借自动化的测试流程、灵活的配置选项和强大的可扩展性，助力你在验证过程中事半功倍。让你无需担心遗漏任何细节，性能提升，质量更有保障。",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/agents.png',
  },
  {
    title: "Workflow",
    desc: "测试再也不是一项繁琐的工作！我们的工作流系统通过智能化的自动化流程，使测试工作高效且精准。从设置到执行，每个步骤都经过精心优化，最大程度地减少人为操作错误，确保每一次测试都能够完美执行。灵活的配置和全面的支持，帮助你轻松应对任何复杂的设计挑战。",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/workflows.png',
  },
  {
    title: "RTL生成",
    desc: "让设计飞得更高，行得更稳！CoChiper不仅是一个辅助工具，更是你设计旅程中的得力助手。通过先进的智能算法，它能快速分析你的设计需求，提供最佳的优化方案。在你的每一个决策背后，CoChiper都在默默为你提供支持，让每一步都走得更加精准，确保你在设计过程中无往不利。",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/copilot.png',
  },
]


export const IcrdFirends = [
  {
    title: "纳能微电子（企业）",
    url: "https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/nnw.png",
    website: 'http://www.nanengmicro.com/'
  },
  {
    title: "长沙锐逸微电子（企业）",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/rvyi.png',
    website: 'https://www.ruiyimicro.com.cn/'
  },
  {
    title: "刘某（个人）",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/lh.png',
  },
  {
    title: "芯云凌（企业）",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/xly.png',
    website: 'https://www.atrontech.com/xsxw',
  }
]

export const ThePicsEN = [
  {
    title: "Verilog Simulation",
    desc: "Accurate verification starts with every line of code! Verilog simulation allows you to easily manage complex hardware designs. Efficient, precise, and comprehensive, it captures every signal, making the debugging process smooth and enjoyable. Whether it's simulation testing or performance validation, our tools will help you solve every challenge in your design efficiently, creating flawless chip designs.",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/simEN.png'
  },
  {
    title: "RTL2GDS",
    desc: "From design blueprint to actual layout, just one step! RTL2GDS breaks down the barriers in the design process, completing the perfect conversion from RTL code to GDS file with a single click. The smooth output process and reliable results ensure the efficiency and quality of your design, leading your chip from concept to realization with perfect presentation.",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/rtl2gdsEN.png',
  },
  {
    title: "Agents",
    desc: "Pushing testing towards an intelligent future! The Agent system not only simulates every behavior in a real-world environment but also deeply uncovers hidden issues. With automated testing processes, flexible configuration options, and strong scalability, it helps you achieve double the result with half the effort during verification. You can rest assured that no details are missed, ensuring improved performance and guaranteed quality.",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/agentsEN.png',
  },
  {
    title: "Workflow",
    desc: "Testing is no longer a tedious task! Our workflow system uses intelligent automation to make testing both efficient and precise. From setup to execution, every step is carefully optimized, minimizing human errors and ensuring each test runs perfectly. Flexible configuration and comprehensive support help you easily handle any complex design challenge.",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/workflowsEN.png',
  },
  {
    title: "RTL Generation",
    desc: "Take your design higher and steadier! CoChiper is not just an assistant tool, but a reliable partner in your design journey. Using advanced intelligent algorithms, it can quickly analyze your design needs and provide the best optimization solutions. Behind every decision you make, CoChiper is silently supporting you, ensuring each step is precise and making your design process smoother and more successful.",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/copilotEN.png',
  },
]

export const IcrdFirendsEN = [
  {
    title: "Naneng Micro (Company)",
    url: "https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/nnwEN.png",
    website: 'http://www.nanengmicro.com/'
  },
  {
    title: "Ruiyi Micro (Company)",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/rvyiEN.png',
    website: 'https://www.ruiyimicro.com.cn/'
  },
  {
    title: "Liu (Individual)",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/lhEN.png',
  },
  {
    title: "Atrontect (Company)",
    url: 'https://zhenwo-brain-docs.oss-cn-beijing.aliyuncs.com/cochiper/xlyEN.png',
    website: 'https://www.atrontech.com/xsxw',
  }
]
